'use strict';

import register from './core';

register('video-on-play', function (element) {
  element.addEventListener("play", function () {
    var controlId = element.getAttribute('data-control');
    setControlMessage(controlId, element.paused);
  });
});

register('video-control-toggle', function (element) {
  element.addEventListener("click", function () {
    var videoId = element.getAttribute('data-target');
    var videoElm = document.getElementById(videoId);

    setVideoTogglePlayPause(videoElm);

    setControlMessage(element.getAttribute('id'), videoElm.paused);
  });
});

var setControlMessage = function (controlId, isPaused) {
  var controlElm = document.getElementById(controlId),
    playText = controlElm.getAttribute('data-text-play'),
    pauseText = controlElm.getAttribute('data-text-pause');
  controlElm.className = (isPaused) ? "video-control-paused" : "video-control-playing";
  controlElm.innerHTML = (isPaused) ? playText : pauseText;
};

var setVideoTogglePlayPause = function (videoElm) {
  if (videoElm.paused) {
    videoElm.play();
  } else {
    videoElm.pause();
  }
};
